<template>
  <Page>
    <div class="topimg"></div>
    <div class="con">
      <div class="title-box">
          <h4 class="fs16 mb25">{{data.created_at}}</h4>
          <h2 class="fs24">{{data.title}}</h2>
      </div>
      <div class="html-con" v-html="data.contents">
       
      </div>
    </div>
  </Page>
</template>

<script>
import Page  from '@/components/page.vue'
import { getNewsDetail } from '@/api/dynamic'



export default {
  name: '',
  components:{Page},
  data(){
    return {
      data:{}
    }
  },
  mounted(){
    // console.log(this.$route.params.id);
    getNewsDetail(this.$route.params.id).then((res)=>{
      console.log(res);
      let remark = "";
      let keyword = ""
      this.data=res;

      remark = res.remark;
      keyword = !!res.keyword?res.keyword:"国际陶瓷展,潭洲陶瓷展,陶瓷展,装备展,潭洲展会,陶瓷与卫浴,陶瓷装备与材料,陶瓷产品展览会";
      document.querySelector('meta[name="keywords"]').setAttribute('content', keyword);
      document.querySelector('meta[name="description"]').setAttribute('content',remark);
      // document.title = res.title;
    })
  },
  methods:{
  
  }
}
</script>

<style scoped>
.con{padding:4.47vw 5.26vw;}
.con .html-con{width:950px;}
.title-box{padding-bottom:1.47vw; border-bottom:1px solid #e6e6e6;}
.title-box h4{color:#868686; font-weight: normal;}
.title-box h2{color:#222;}

.html-con{padding:2vw 0;}

@media (max-width:991px){
.con{padding:6vw 1.5vw;}
.con .html-con{ width:97vw;}
}
</style>

<style>
.con .html-con img{max-width: 950px; width:auto!important; height:auto!important;}

@media (max-width:991px){
  .con .html-con img{max-width: 97vw; width:auto!important; height:auto!important;}
}
</style>
